import { render, staticRenderFns } from "./HomeBannerUser.vue?vue&type=template&id=71a5217e&scoped=true"
import script from "./HomeBannerUser.vue?vue&type=script&lang=js"
export * from "./HomeBannerUser.vue?vue&type=script&lang=js"
import style0 from "./HomeBannerUser.vue?vue&type=style&index=0&id=71a5217e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a5217e",
  null
  
)

export default component.exports